// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__J+Yyw","citation":"Footer_citation__Xr9nm","license":"Footer_license__-THd6"};